import { loadStripe, Stripe } from "@stripe/stripe-js";
import { supabase } from "@/integrations/supabase/client";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN;
const environment = clientToken?.startsWith('pk_test_') ? 'sandbox' : 'live';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    if (!clientToken) {
      throw new Error("VITE_PAYMENTS_CLIENT_TOKEN is not set");
    }
    stripePromise = loadStripe(clientToken);
  }
  return stripePromise;
}

export async function getStripePriceId(priceId: string): Promise<string> {
  const { data, error } = await supabase.functions.invoke("get-stripe-price", {
    body: { priceId, environment },
  });
  if (error || !data?.stripeId) {
    throw new Error(`Failed to resolve price: ${priceId}`);
  }
  return data.stripeId;
}

export function getStripeEnvironment(): string {
  return environment;
}

// Plan configuration
export const PLANS = {
  monthly: {
    priceId: "monthly",
    name: "Monthly",
    price: "$14.99/month",
    session_limit: 100,
  },
  annual: {
    priceId: "annual",
    name: "Annual",
    price: "$99/year",
    session_limit: 300,
  },
} as const;

export const FREE_SESSION_LIMIT = 10;

export type PlanKey = keyof typeof PLANS;

export function getSessionLimit(tier: PlanKey | "free"): number {
  if (tier === "free") return FREE_SESSION_LIMIT;
  return PLANS[tier].session_limit;
}
